import { ACCOUNT_URI, CLIENT_ID, CLIENT_NAME, PASSPORT_URI } from '@cores/constants/envConfig';
import _ from 'lodash';
import qs from 'qs';
import { stoper } from '@cores/startup/token-base';
import { UserCenterService } from '@patsnap-utils/biz';
import { isFreePath } from '@cores/apis/interceptors/workspace_free.interceptor';
import { injectService } from '@patsnap/tahiti-core';
import { UserInfoService } from '@/domains/user/services/user-info-service.interface';
export const redirectFn = _.throttle(function (error) {
    const redirectUrl = _.get(error, 'data.redirect_url');
    if (redirectUrl) {
        window.location.href = redirectUrl;
    }
    else if (error && error.errcode) {
        // 被踢出到登录页
        window.location.href = UserCenterService.createLogoutHref(true, { errorCode: error.errcode });
    }
    else {
        // 其他需要登陆的操作
        window.location.href = UserCenterService.createLogoutHref(true, {
            errorCode: 39999,
        });
    }
}, 1000);
export const initializeConfig = {
    baseAuthServer: PASSPORT_URI,
    clientId: CLIENT_ID,
    clientName: CLIENT_NAME,
    autoRun: false,
    redirectToLogin(error) {
        const userInfoService = injectService(UserInfoService);
        /**
         * is_free 为 true 时，用户未登录，公开分享模式
         * is_free 为 false 时，用户登录
         * is_free 为 undefined 时，初始化完成前的状态，
         * 公开分享模式和初始化完成前的状态都不需要跳转到登录页
         */
        const isLogin = userInfoService.userInfo.is_free === false;
        const canSkip = isFreePath();
        if (canSkip && !isLogin)
            return;
        console.warn('Check Session Error, Will Redirect To Login Page!');
        stoper();
        redirectFn(error);
    },
    syncTokenParamsModifier(params) {
        const data = {
            ...params,
        };
        return data;
    },
    detectResponseAsUnauthorized(error) {
        const redirectUrl = _.get(error, 'response.data.redirectUrl');
        if (redirectUrl) {
            stoper();
            window.location.href = redirectUrl;
            throw error;
        }
        return _.get(error, 'response.status') === 401;
    },
    onPaymentRequired(error) {
        // 自己跳转到付费页面
        const errcode = _.get(error, 'errcode');
        const urlParams = {
            from: CLIENT_NAME,
            client_id: CLIENT_ID,
            redirect_uri: encodeURIComponent(window.location.href),
            errorCode: errcode,
        };
        const url = `${ACCOUNT_URI}/user-settings/#/upper-limit${qs.stringify(urlParams, { addQueryPrefix: true })}`;
        stoper();
        window.location.replace(url);
    },
    async onMfaRequired(error) {
        const errcode = _.get(error, 'errcode');
        const urlParams = {
            from: CLIENT_NAME,
            client_id: CLIENT_ID,
            redirect_uri: encodeURIComponent(window.location.href),
            errorCode: errcode,
        };
        const url = `${ACCOUNT_URI}/user-settings/#/mfa-required${qs.stringify(urlParams, { addQueryPrefix: true })}`;
        stoper();
        window.location.replace(url);
    },
    onTokenRefresh(err) {
        console.log('onTokenRefresh', err);
    },
};
